import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { MatDialog } from '@angular/material';
import { SegundaViaModalBoletoComponent } from './segundavia-modal-boleto.component';
import { AbstractComponent } from '../util/abstract.component';
import { SessaoService } from '../services/sessao.service';
import { SegundaViaService } from '../services/segundavia.service';
import { MensagemService } from '../services/mensagem.service';
import { RestClientService } from '../services/restclient.service';
import { Contrato } from '../modelo/contrato';
import { Parcela } from '../modelo/parcela';
import { Boleto } from '../modelo/boleto';
import { SegundaViaContrato } from '../modelo/segundaViaContrato';
import { Config } from '../services/config';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

declare var $: any;

@Component({
  selector: 'app-segundavia-contrato',
  templateUrl: './segundavia-contrato.component.html',
  styleUrls: ['./segundavia.component.css'],
  providers: [SegundaViaService, MensagemService, RestClientService]
})
export class SegundaViaContratoComponent extends AbstractComponent implements OnInit {

  contrato: Contrato = new Contrato();
  boleto: Boleto = new Boleto()

  constructor(
    private sessaoService: SessaoService,
    private segundaViaService: SegundaViaService,
    private mensagemService: MensagemService,
    private router: Router,
    private spinnerService: Ng4LoadingSpinnerService,
    public dialog: MatDialog) {
    super(sessaoService);
  }

  ngOnInit() {
    //Scroll top
    window.scrollTo(0, 0);
    this.contrato = JSON.parse(sessionStorage.getItem('segundaViaContrato'));
    this.recuperarContrato(this.contrato);

    // Close Menu Mobile
    var isMobile = window.matchMedia("only screen and (max-width: 760px)");
    $(".content").click(function() {
      if (isMobile.matches) {
        $(".page").removeClass("toggled");
      }
    });
  }

  recuperarContrato = (contrato: Contrato): void => {
    this.segundaViaService.recuperarContrato(contrato).subscribe(
      (result: Contrato) => {
        if (result.cdMsgemRetorno == "0") {
          this.contrato = result;
        }
      },
      (error: Response) => {
        this.mensagemService.servicoIndisponivel(this.getMensagem("ERRO_CHAMADA_SERVICO"));
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  onClickParcela(parcela: Parcela, contrato: Contrato): void {
    let dialogRef = this.dialog.open(SegundaViaModalBoletoComponent, {
      width: Config.POPUP_100VW,
      panelClass: 'modal-boleto-bottom',
      data: {
        parcela: parcela,
        contrato: contrato
      }
    });
  }

}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/bf-segundavia-cli/segundavia-contrato.component.ts